module.exports = __webpack_public_path__ + "src/assets/games/19/12.jpg";